'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const OrganizationProfileData=require('../../../../dist-es6/client/dtos/organizationProfileData');
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');let

BaseOrganizationProfileController=(_class=class BaseOrganizationProfileController extends BaseController{
static get $inject(){
return['$state','$timeout','userService','socketService','uncaughtErrorHandler'];
}

constructor($state,$timeout,userService,socketService,uncaughtErrorHandler){
super(uncaughtErrorHandler);
this._initialLoadComplete=!1;

this._socketService=socketService;
this._userService=userService;
this._$state=$state;
this._$timeout=$timeout;

if(_.get(userService,'currentUser.role')!=='admin'){
$state.go('fdc.features.profile');
return;
}

this._reloadProfileData();
}

get isCurrentUserPrimary(){return _.get(this._userService,'currentUser.isPrimary')}

get profileData(){return this._profileData}

get organizationName(){return _.get(this,'profileData.name')}
get contractStartDate(){return _.get(this,'profileData.contractStartDate')}
get serviceStartDate(){return _.get(this,'profileData.serviceStartDate')}
get serviceEndDate(){return _.get(this,'profileData.serviceEndDate')}
get primaryUserId(){return _.get(this,'profileData.primaryUserId')}
get dataRetentionPeriodMs(){return _.get(this,'profileData.dataRetentionPeriodMs')}
get users(){return _.get(this,'profileData.users')}

get initialLoadComplete(){return this._initialLoadComplete}


async _reloadProfileData(){
let orgProfileDataResponse=await this._socketService.sendAndWaitForResponse('GetOrganizationProfileData');
if(!SocketResponse.succeeded(orgProfileDataResponse)){
return;
}

this._$timeout(()=>{
this._profileData=OrganizationProfileData.fromJSON(orgProfileDataResponse.body);
this._initialLoadComplete=!0;
});
}},(_applyDecoratedDescriptor(_class.prototype,'_reloadProfileData',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_reloadProfileData'),_class.prototype)),_class);


module.exports=BaseOrganizationProfileController;
//# sourceMappingURL=baseOrganizationProfileController.js.map
